export const insuranceVerificationKeys = {
  documents: (companyId: number) =>
    ["insurance", "documents", companyId] as const,
  document: (companyId: number, documentId: number) =>
    ["insurance", "document", companyId, documentId] as const,
  usage: (companyId: number) => ["insurance", "usage", companyId] as const,
  ocrJob: (companyId: number, ocrJobId: number) =>
    ["insurance", "ocr-job", companyId, ocrJobId] as const,
};
